import './styles.css';
import { initFooter } from './js/footer.js';
import { initApp } from './js/views.js';

initFooter();
initApp();
